import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=2bfeced4"
import script from "./BaseDialog.js?vue&type=script&lang=js&external"
export * from "./BaseDialog.js?vue&type=script&lang=js&external"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=2bfeced4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfeced4')) {
      api.createRecord('2bfeced4', component.options)
    } else {
      api.reload('2bfeced4', component.options)
    }
    module.hot.accept("./BaseDialog.vue?vue&type=template&id=2bfeced4", function () {
      api.rerender('2bfeced4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base-dialog/BaseDialog.vue"
export default component.exports